import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, EmployeeId } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function projectsTimesheet(projectPay) {
    let url = 'timesheet/projects?' + objectToQueryString({ projectPay: projectPay, userCode: UserCode(), employeeId: EmployeeId(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let projects = response.projects;

                //saveProjects(projects);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortProject(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.projectEn.toLowerCase() : a.projectFr.toLowerCase()
        const nameB = IsEnglish() ? b.projectEn.toLowerCase() : b.projectFr.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortProjectByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.project
        const nameB = b.project
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}